import React from "react";
import { Link } from "react-router-dom";
import { Check, ShieldCheck, Truck, Sparkles } from "lucide-react";
import { fmtEUR, fmtInt } from "@/lib/api";
import { CALCULATOR } from "@/data/content";

export const QuotePanel = ({ pricing, screenMeta, qty, quote, priceActive = true }) => (
  <div className="lg:sticky lg:top-24">
    <div data-testid="calculator-quote-panel" className="overflow-hidden rounded-3xl border border-black/10 bg-ink text-white shadow-2xl">
      <div className="border-b border-white/10 p-6 sm:p-7">
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Η προσφορά σας</div>
        <div className="mt-4 space-y-2.5 text-sm">
          <div className="flex justify-between">
            <span className="text-white/55">Οθόνη</span>
            <span className="font-medium text-white">{screenMeta?.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-white/55">Ποσότητα</span>
            <span className="font-medium text-white">{fmtInt(qty)} τεμ.</span>
          </div>
          {priceActive && (
            <div className="flex justify-between">
              <span className="text-white/55">Τιμή / τεμάχιο</span>
              {quote?.percent > 0 ? (
                <span data-testid="calculator-unit-price" className="font-medium text-white">
                  <span className="mr-2 text-white/40 line-through">{fmtEUR(quote?.unit)}</span>
                  <span className="text-brand-400">{fmtEUR(quote?.unitNet)}</span>
                </span>
              ) : (
                <span data-testid="calculator-unit-price" className="font-medium text-white">{fmtEUR(quote?.unit)}</span>
              )}
            </div>
          )}
          {priceActive && quote?.percent > 0 && (
            <>
              <div className="flex justify-between">
                <span className="text-white/55">Υποσύνολο</span>
                <span className="text-white/80">{fmtEUR(quote.subtotal)}</span>
              </div>
              <div className="flex justify-between text-brand-400">
                <span>Έκπτωση ({quote.percent}%)</span>
                <span>−{fmtEUR(quote.discountAmount)}</span>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="p-6 sm:p-7">
        {priceActive ? (
          <div className="flex items-end justify-between">
            <span className="text-sm text-white/55">Γενικό σύνολο</span>
            <span data-testid="calculator-total-price" className="font-display text-3xl font-bold text-brand-500 sm:text-4xl">
              {fmtEUR(quote?.total)}
            </span>
          </div>
        ) : (
          <div>
            <span className="text-sm text-white/55">Γενικό σύνολο</span>
            <div data-testid="calculator-total-price" className="mt-1 font-display text-3xl font-bold leading-tight text-brand-500">
              Ζητήστε προσφορά
            </div>
          </div>
        )}
        <div className="mt-6 space-y-2.5">
          {pricing.includes.map((inc) => (
            <div key={inc} className="flex items-start gap-2.5 text-sm text-white/75">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-500" />
              <span>{inc}</span>
            </div>
          ))}
        </div>
        <div className="mt-6 grid grid-cols-3 gap-2 border-t border-white/10 pt-5 text-center">
          <div className="flex flex-col items-center gap-1.5 text-[12px] text-white/55">
            <Truck className="h-4 w-4 text-brand-500" /> Δωρεάν Παράδοση
          </div>
          <div className="flex flex-col items-center gap-1.5 text-[12px] text-white/55">
            <ShieldCheck className="h-4 w-4 text-brand-500" /> Χωρίς κρυφές χρεώσεις
          </div>
          <div className="flex flex-col items-center gap-1.5 text-[12px] text-white/55">
            <Sparkles className="h-4 w-4 text-brand-500" /> Custom design
          </div>
        </div>
        <p className="mt-5 text-[14px] leading-relaxed text-white/40">{CALCULATOR.inclusiveNote}</p>
        <p className="mt-2 text-[14px] font-medium text-white/55">{CALCULATOR.validityNote}</p>
      </div>
    </div>

    <p className="mt-4 px-2 text-center text-[14px] text-black/45">
      Χρειάζεστε βοήθεια; <Link to="/#contact" className="font-semibold text-brand-500 hover:underline">Επικοινωνήστε μαζί μας</Link>
    </p>
  </div>
);
